// src/components/blogs/BlogPagination.jsx
import React from 'react'
import ReactPaginate from 'react-paginate'

const BlogPagination = ({ pageCount, handlePageClick }) => {
    return (
        <div className="text-center">
            <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={'pagination mb-5'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
            />
        </div>
    )
}

export default BlogPagination
